<template>
  <form-group>
    <conta-card-display-shimmer
      v-if="loading && !hasClients"
    />
    <v-row v-else>
      <v-col cols="12">
        <v-tabs
          v-if="display"
          v-model="tabs"
        >
          <v-tab
            v-for="({ document, id }, idx) in clientTabs"
            :key="makeKeyName('client_tab', document, idx)"
            ripple
          >
            {{ document }} ({{ id }})
          </v-tab>
          <v-tabs-items
            v-model="tabs"
          >
            <v-tab-item
              v-for="(client, idx) in clients"
              :key="makeKeyName('client_tab_item', client, idx)"
            >
              <v-row class="pt-6">
                <v-col cols="12">
                  <conta-card-content
                    :value="client"
                    :pin="getPinByClient(client)"
                  />
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <form-group
          v-if="!loading && !hasClients"
          id="hasNotClient"
        >
          <v-row
            justify="center"
            align="center"
            class="text-center"
          >
            <span>Usuário não possui nenhum cliente cardmais</span>
          </v-row>
        </form-group>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ClientRequest from '@/app/client/ClientRequest';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import ContaCardDisplayShimmer from 'App/users/components/shimmers/ContaCardDisplayShimmer.vue';
import DocumentFilter from 'Arch/filters/DocumentFilter';
import ContaCardContent from 'App/users/components/contents/ContaCardContent.vue';
import UsersPinRequest from 'App/users/services/UsersPinRequest';

export default {
  name: 'ContaCardDisplay',
  components: { FormGroup, ContaCardDisplayShimmer, ContaCardContent },
  mixins: [ServiceMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
    userSystem: {
      type: Object,
      default() {
        return {
          id: '',
          clients: [],
        };
      },
    },
  },
  data: () => ({
    requestClass: ClientRequest,
    requestPin: UsersPinRequest,
    loading: false,
    loadingPin: false,
    tabs: null,
    config: {
      errorMessage: 'Falha ao buscar clientes deste usuário!',
      showSuccessSwal: false,
    },
    clients: [],
    userPin: {
      isLoginTempBlocked: '',
      isLoginPermBlocked: '',
      clients: [],
    },
    pinFaultMessage: 'Falha ao buscar informações do pin do usuário!',
  }),
  computed: {
    user() {
      return this.userSystem || {};
    },
    userId() {
      return this.user.id;
    },
    clientTabs() {
      return this.clients.map(
        (client) => ({
          document: DocumentFilter(
            client.cpfCnpj,
          ),
          id: client.id,
        }),
      );
    },
    hasClients() {
      return this.clients.length >= 1;
    },
    display() {
      return !this.loading && this.hasClients;
    },
    configPin() {
      return {
        ...this.config,
        errorMessage: this.pinFaultMessage,
      };
    },
    getPinByClient() {
      return (client) => {
        const info = this.userPin.clients.find(
          (c) => c.id === client.id,
        ) || {};
        return {
          ...info,
          client: this.getUserSystemClient(client) || {},
        };
      };
    },
    getUserSystemClient() {
      return (client) => this.userPin.clients.find(
        (c) => c.id === client.id,
      );
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(id) {
        if (Number(id) >= 1) {
          this.getData();
        }
      },
    },
  },
  created() {
    this.reloadByAnalysisTable();
  },
  methods: {
    getData() {
      this.handleLoading();
      this.handleLoadingPin();
      this.makeRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    handleLoadingPin() {
      this.loadingPin = !this.loadingPin;
    },
    makeRequest() {
      this.getPinInfo();
      this.getClients();
    },
    getPinInfo() {
      this.callService(
        this.requestPin.get(
          this.userId,
        ),
        this.configPin,
        this.setPinInfo,
      );
    },
    setPinInfo(response) {
      this.handleLoadingPin();
      if (this.hasData(response)) {
        this.userPin = this.overrideNullProperties(
          response.data,
          this.userPin,
        );
      }
    },
    getClients() {
      this.callService(
        this.requestClass.listClientsByUser(
          this.userId,
          this.makeParams(),
        ),
        this.config,
        this.setClientList,
      );
    },
    setClientList(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.clients = this.prepareData(
          response.data,
        );
      }
    },
    reloadByAnalysisTable() {
      this.$root.$on(
        'reload-analysisTable-father',
        (bool) => {
          if (bool) {
            this.clients = [];
            this.$nextTick(
              () => {
                this.getData();
              },
            );
          }
        },
      );
    },
  },
  inject: {
    makeKeyName: {
      default() {
        return (v) => v;
      },
    },
  },
  reactiveProvide: {
    name: 'contacard',
    includes: ['loadingPin'],
  },
  provide() {
    return {
      reloadPin: this.getPinInfo,
    };
  },
};
</script>
